import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { FONTS, textLG } from '@styles/fonts'
import styled, { css } from 'styled-components'

export const StickyNavAgent = styled.div`
  position: sticky;
  display: flex;
  align-items: center;
  top: 0;
  z-index: 999;
  opacity: 0;
  background-color: ${COLORS.white};
  transition: all 0.25s;
  box-shadow: 3px 3px 8px 0px rgba(112, 112, 112, 0.13);

  ${({ active }) =>
    active &&
    css`
      top: 0;
      opacity: 1;
    `}

  @media ${DEVICES.tablet} {
    display: none;
  }
`

export const Agent = styled.div`
  border-right: 1px solid ${COLORS.grey[10]};
  padding: 24px 42px;
  display: flex;
  align-items: center;
  max-width: 32%;

  > div:first-child {
    margin-right: 20px;
    flex: 0 0 64px;
  }

  img {
    width: 64px;
    height: 64px;
    object-fit: cover;
    border-radius: 50%;
    object-position: top center;
  }
`

export const AgentInfo = styled.div`
  color: ${COLORS.secondary};
  overflow: hidden;
`

export const AgentInfoName = styled.h4`
  ${textLG};
  margin-bottom: 2px;
  letter-spacing: 1.2px;
`

export const AgentInfoJobTitle = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StickyNavAgentActions = styled.div`
  flex: 1;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 10px;

  > div > button,
  > div > a {
    margin-right: 10px;
  }

  .share-button {
    margin-left: auto;

    div {
      margin-right: 0;
    }
  }
`

export const SaveContact = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.25s ease-in;

  &:hover {
    color: ${COLORS.primary};
    text-decoration: underline;
  }

  svg {
    margin-right: 4px;
  }
`

export const ShareAction = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  gap: 20px;
  color: ${COLORS.secondary};
`
